import classNames from 'classnames';
import React from 'react';

export interface ModalBodyProps extends React.HTMLAttributes<HTMLElement> {
  tag?: React.ElementType;
  [key: string]: any;
}

const ModalBody = ({ className, tag: Tag = 'div', ...attributes }: ModalBodyProps) => {
  return <Tag {...attributes} className={classNames(className, 'modal-body')} />;
};

export default ModalBody;
